<template>
  <section class="EventCards-styles-event-cards-wrapper">
    <div class="HorizontalScroller-styles-child-container EventCards-styles-cards-container HorizontalScroller-styles-child-animation" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
      <div class="EventCards-styles-banner-event-card" style="display: none;">
        <a href="javascript:;" rel="noopener noreferrer" class="CustomEventCardBanner-styles-banner-list">
          <img class="" src="/static/assets/img/EventCards_Promo_TR.jpg" alt="app.eventCard.promoBannerAlt" width="218" height="134">
        </a>
        <div class="EventCards-styles-card-separator"></div>
      </div>
      <div class="EventCards-styles-banner-event-card" v-for="event in events" v-if="event.type === 'event'">
        <div>
          <div>
            <div class="EventCardItem-styles-card-wrapper">
              <div class="EventCardItem-styles-flex-column-container">
                <div class="EventCardItem-styles-flex-container">
                  <img class="EventCardItem-styles-sport-icon" :src="'/static/assets/img/'+ event.sport.alias +'.png'" loading="lazy" width="16" height="16">
                  <div class="EventCardItem-styles-league">{{ event.region.name }}</div>
                  <div class="EventCardItem-styles-live">{{ t.live }}</div>
                  <div class="EventCardItem-styles-date EventCardItem-styles-bold">{{ periodTimer(event) }} </div>
                </div>
                <router-link :to="{name: 'Sportsbook', params: {event: event.matchId}}">
                <div class="EventCardItem-styles-flex-container EventCardItem-styles-middle-row">
                  <div class="EventTeams-styles-event-teams EventTeams-styles-additional-margin EventTeams-styles-event-cards">
                    <div class="EventTeams-styles-titles">
                      <div class="EventTeams-styles-team EventTeams-styles-event-team">
                        <span class="EventTeams-styles-team-title">{{ event.competitor.oneName }}</span>
                      </div>
                      <div class="EventTeams-styles-team EventTeams-styles-event-team">
                        <span class="EventTeams-styles-team-title">{{ event.competitor.twoName }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="EventScores-styles-scores EventScores-styles-event-cards-scores">
                    <div class="EventScores-styles-score EventScores-styles-score" v-if="event.data.infos.hasOwnProperty('1st half')">
                      <div class="EventScores-styles-point EventScores-styles-current-point EventScores-styles-half-time">{{ event.data.infos.stats['1st half'].score.home }}</div>
                      <div class="EventScores-styles-point EventScores-styles-current-point EventScores-styles-half-time">{{ event.data.infos.stats['1st half'].score.away }}</div>
                    </div>
                    <div class="EventScores-styles-score EventScores-styles-score" v-if="event.data.hasOwnProperty('score')">
                      <div class="EventScores-styles-point EventScores-styles-current-point EventScores-styles-large-current-point EventScores-styles-no-margin" v-if="event.data.score">{{ event.data.score.home }}</div>
                      <div class="EventScores-styles-point EventScores-styles-current-point EventScores-styles-large-current-point EventScores-styles-no-margin" v-if="event.data.score">{{ event.data.score.away }}</div>
                    </div>
                  </div>
                </div>
                </router-link>
                <div class="pt-2">
                  <market :markets="event.odds" :selected="[5498]" :match="event" />
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="EventCards-styles-card-separator"></div>
      </div>

    </div>
    <div @click="moveCarousel(1)" class="HorizontalScroller-styles-arrow-container HorizontalScroller-styles-arrow-container-right EventCards-styles-arrow-container EventCards-styles-arrow-container-right HorizontalScroller-styles-arrow-animation">
      <img src="/static/assets/img/scroll-arrow-right.svg" class="HorizontalScroller-styles-arrow">
    </div>
    <div @click="moveCarousel(-1)" v-show="!atHeadOfList" class="HorizontalScroller-styles-arrow-container HorizontalScroller-styles-arrow-container-left EventCards-styles-arrow-container EventCards-styles-arrow-container-left HorizontalScroller-styles-arrow-animation"><img src="/static/assets/img/scroll-arrow-left.svg" class="HorizontalScroller-styles-arrow"></div>
  </section>
</template>

<script>

import market from '@/components/sportsbook/market/cardMarket'
import fixture from '../../mixins/fixture';

export default {
  name: 'billboard',
  components: {market},
  mixins: [fixture],
  data () {
    return {
      t: this.$root.t,
      events: null,
      currentOffset: 0,
      windowSize: 3,
      paginationFactor: 250,

    }
  },
  computed: {
    atEndOfList() {
      return this.currentOffset <= (this.paginationFactor * -1) * (this.events.length - this.windowSize);
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  mounted () {
    this.fetchEvents();


  },
  methods: {
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },

    fetchEvents() {
      this.$http.get(bsapi+'api/v2/fixture/full', {
        params: {onLive: 1, onlyList: 1}
          }
      ).then(response => {
        this.events = this.compileList(response.body.result);

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.swiper-slide {
  width: 240px !important;
}
.swiper-button-disabled {
  display: none;
}
.EventCards-styles-banner-event-card {
  max-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/billboard.vue